(function($) {

  /* Traduzioni — usa window.mtgWishI18n se disponibile (iniettato da theme.liquid) */
  var i18n = window.mtgWishI18n || {
    available:      '● Disponibile',
    unavailable:    '● Non disponibile',
    go_to_product:  'Vai al prodotto',
    sold_out:       'Esaurito',
    remove:         'Rimuovi',
    in_wishlist:    'In wishlist',
    add_to_wishlist:'Lista dei desideri'
  };

  /* CSS cuore pieno quando in wishlist */
  (function() {
    var s = document.createElement('style');
    s.textContent =
      '.js-wishlist-toggle.in-wishlist svg path { fill: #B00E0A; stroke: #B00E0A; transition: fill .2s, stroke .2s; }' +
      '.js-wishlist-toggle.in-wishlist i { color: #B00E0A; }' +
      '.js-wishlist-toggle svg path { transition: fill .2s, stroke .2s; }';
    document.head.appendChild(s);
  })();

  var WL_KEY = 'mtg_wishlist';

  function getList() {
    try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); }
    catch(e) { return []; }
  }

  function saveList(list) {
    try { localStorage.setItem(WL_KEY, JSON.stringify(list)); }
    catch(e) { console.warn('Wishlist: impossibile salvare in localStorage', e); }
  }

  function isInList(id) {
    if (!id || id === 'undefined') return false;
    return getList().some(function(p) { return String(p.id) === String(id); });
  }

  function addToList(product) {
    if (!product.id || String(product.id) === 'undefined') return false;
    if (!isInList(product.id)) {
      var list = getList();
      list.push(product);
      saveList(list);
    }
    return true;
  }

  function removeFromList(id) {
    saveList(getList().filter(function(p) { return String(p.id) !== String(id); }));
  }

  /* Toast notifica */
  function showToast(msg, link) {
    var $t = $('#mtg-wl-toast');
    if (!$t.length) {
      $('body').append('<div id="mtg-wl-toast" style="'
        + 'position:fixed;bottom:80px;left:50%;transform:translateX(-50%);'
        + 'background:#1e1e1e;color:#fff;padding:12px 20px;border-radius:6px;'
        + 'border-left:4px solid #B00E0A;font-size:13px;z-index:99999;'
        + 'box-shadow:0 4px 20px rgba(0,0,0,0.5);display:none;white-space:nowrap;"></div>');
      $t = $('#mtg-wl-toast');
    }
    var html = msg;
    if (link) html += ' &nbsp;<a href="' + link + '" style="color:#B00E0A;font-weight:700;text-decoration:none;">Vedi lista →</a>';
    $t.html(html).fadeIn(200);
    clearTimeout($t.data('timer'));
    $t.data('timer', setTimeout(function() { $t.fadeOut(300); }, 3000));
  }

  /* Aggiorna aspetto bottoni */
  function updateButtons() {
    $('.js-wishlist-toggle').each(function() {
      var id = String($(this).data('product-id'));
      if (!id || id === 'undefined') return;
      if (isInList(id)) {
        $(this).addClass('in-wishlist');
        $(this).find('.js-wl-label').text(i18n.in_wishlist);
      } else {
        $(this).removeClass('in-wishlist');
        $(this).find('.js-wl-label').text($(this).data('label-default') || '');
      }
    });
  }

  /* Renderizza prodotti nella pagina wishlist */
  function renderWishlistPage() {
    var $grid = $('#mtg-wish-grid-js');
    if (!$grid.length) return;

    var list = getList();

    if (list.length === 0) {
      $('#mtg-wish-content').hide();
      $('#mtg-wish-empty-js').show();
      return;
    }

    $('#mtg-wish-empty-js').hide();
    $('#mtg-wish-content').show();
    $('.mtg-wish-count-js').text(list.length);

    var html = '';
    var validList = list.filter(function(p) { return p.url && p.url !== 'undefined' && p.url !== 'null'; });
    if (validList.length !== list.length) { saveList(validList); }
    validList.forEach(function(p) {
      var avail     = (p.available === 'true' || p.available === true);
      var stockCls  = avail ? 'in-stock' : 'out-stock';
      var stockTxt  = avail ? i18n.available : i18n.unavailable;
      var actionBtn = avail
        ? '<a href="' + p.url + '" class="mtg-wish-btn">' + i18n.go_to_product + '</a>'
        : '<span class="mtg-wish-btn disabled">' + i18n.sold_out + '</span>';
      var imgHtml   = p.image ? '<img src="' + p.image + '" alt="' + p.title + '">' : '';

      html += '<div class="mtg-wish-card" id="wish-' + p.id + '">';
      html += '<button type="button" class="mtg-wish-remove js-wishlist-remove" data-product-id="' + p.id + '" title="' + i18n.remove + '">&times;</button>';
      html += '<a href="' + p.url + '" class="mtg-wish-img-wrap">' + imgHtml + '</a>';
      html += '<div class="mtg-wish-body">';
      html += '<a href="' + p.url + '" class="mtg-wish-title">' + p.title + '</a>';
      html += '<div class="mtg-wish-price">' + p.price + '</div>';
      html += '<div class="mtg-wish-stock ' + stockCls + '">' + stockTxt + '</div>';
      html += actionBtn;
      html += '</div></div>';
    });

    $grid.html(html);
  }

  $(document).ready(function() {
    console.log('[WL] ready, bottoni:', $('.js-wishlist-toggle').length);
    updateButtons();
    renderWishlistPage();

    /* Click aggiungi/rimuovi wishlist */
    $(document).on('click', '.js-wishlist-toggle', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var $btn = $(this);
      var id   = String($btn.data('product-id'));
      var url  = $btn.data('product-url');
      console.log('[WL] click id:', id, 'url:', url);

      if (!id || id === 'undefined') return;

      /* Controllo login: se non loggato, redirect a pagina di login */
      if (!window.mtgCustomerLoggedIn) {
        window.location.href = (window.mtgLoginUrl || '/account/login') + '?return_url=' + encodeURIComponent(window.location.pathname);
        return;
      }

      if (isInList(id)) {
        /* Già in lista: rimuovi (toggle) */
        removeFromList(id);
        $btn.removeClass('in-wishlist');
        $btn.find('.js-wl-label').text($btn.data('label-default') || i18n.add_to_wishlist);
      } else {
        /* Non in lista: aggiungi */
        var product = {
          id        : id,
          title     : $btn.data('product-title'),
          price     : $btn.data('product-price'),
          image     : $btn.data('product-image'),
          url       : $btn.data('product-url'),
          available : String($btn.data('product-available'))
        };
        if (addToList(product)) {
          $btn.addClass('in-wishlist');
          $btn.find('.js-wl-label').text(i18n.in_wishlist);
        }
      }
    });

    /* Rimuovi dalla pagina wishlist */
    $(document).on('click', '.js-wishlist-remove', function(e) {
      e.preventDefault();
      var id = String($(this).data('product-id'));
      removeFromList(id);
      $('#wish-' + id).fadeOut(300, function() { $(this).remove(); });
      setTimeout(function() {
        var count = getList().length;
        $('.mtg-wish-count-js').text(count);
        if (count === 0) {
          $('#mtg-wish-content').hide();
          $('#mtg-wish-empty-js').show();
        }
      }, 350);
    });
  });

  window.initWishlist = function() {};
  window.initProductWishlist = function() {};
  window.initRemoveWishlist = function() {};

})(jQuery);
